import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Semana Lista en Minutos',
  desc: 'Sistema rápido para organizar tu semana sin complicarte',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'Banco Anticaos de Actividades',
  desc: 'Recursos rápidos para cuando una clase no sale como esperabas',
  price: '$6.000 ARS'
}, {
  num: 3,
  title: 'Rutinas de Aula Listas',
  desc: 'Estructuras simples para dar más orden a tus clases',
  price: '$9.000 ARS'
}, {
  num: 4,
  title: 'Juegos Educativos sin Material',
  desc: 'Dinámicas prácticas para activar el aprendizaje sin preparación extra',
  price: '$5.000 ARS'
}, {
  num: 5,
  title: 'Control de Conducta Simple',
  desc: 'Estrategias claras para mejorar el comportamiento sin gritar',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Organización Docente Personal',
  desc: 'Herramientas para ordenar tus tareas, tiempos y pendientes',
  price: '$6.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-36">
      <div className="max-w-xl mx-auto" data-id="element-37">
        <div className="text-center mb-8" data-id="element-38">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-2" data-id="element-39">
            🎁 PERO ESO NO ES TODO... RECIBE TAMBIÉN LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-40">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-41">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-gray-900 border-2 border-yellow-400 rounded-xl p-5 relative overflow-hidden" data-id="element-42">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-43">
                🎁 GRATIS
              </div>

              {/* Bono label */}
              <div className="flex items-center gap-3 mb-2" data-id="element-44">
                <div className="bg-brand-yellow/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-45">
                  <span className="text-lg" data-id="element-46">🎁</span>
                </div>
                <span className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-47">
                  BONO {bonus.num}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-48">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-gray-500 mb-3 leading-relaxed" data-id="element-49">
                {bonus.desc}
              </p>

              {/* Price */}
              <div className="flex items-center gap-2" data-id="element-50">
                <span className="text-sm text-gray-600 line-through" data-id="element-51">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-52">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-gray-900 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-53">
          <p className="text-gray-500 text-sm line-through mb-1" data-id="element-54">
            Valor total: +$41.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-55">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-56">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}